var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.99 41.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-I7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.29a14.69,14.69,0,0,0,2.14,7.19C3,20,5.57,22.55,7.72,22.55c1,0,3-4.4,3.21-5.47,2,0,3.12,0,3.54-1.61-1.26,0-.76.09-1.61-.32.27-3.29,1.58-2.27,2.57-2.25-1.7-1.62-.51-2.12.31-2.58,3.39-1.93.78-1.67,2.91-2.24.72,1.5-.18,2.15.89,3.61.88,1.19,1.14.86,2,2.5-.49.71-.05.39-1,.64.12,1.44.3.61.38,1.67a4.09,4.09,0,0,1-.73,2.36c0,.05-.05.14-.07.18-.06.24.1,1.41.1,2.22-4.05.94-5.35-.57-7.18.86-4.14,3.23,2.29,4.62,3.73,11,.25,1.06.32,5.17-2.66,5.86-1.34-1,.07-.83-1.61-1.28-2.18,3.88,6.32,6.21,11.45-2.38,4.36-7.31,3.89-20.77-.88-27.17-3.75-5-10.19-10.63-16.79-6.9C2.62,3.3,0,6.38,0,11.29Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI7);
export default __webpack_public_path__ + "static/media/I7.a3554ac8ddb1957df128a9b5fadbc605.svg";
export { ForwardRef as ReactComponent };